/** The loan book and the deposit book as shares by product, two tables one above the other (the Peers page and the all-banks drawer share it). */
import type { MarketView } from "@bsim/contracts";
import { PeerTable } from "../theme/PeerTable";
import { mixRows, othersOf } from "./peers";

export function MixTables({ market, mySeatId, testId }: { readonly market: MarketView; readonly mySeatId: string; readonly testId: string }) {
  const names = othersOf(market, mySeatId).map((b) => b.name);
  const mix = (book: "loans" | "deposits", title: string) => {
    const rows = mixRows(market, mySeatId, book);
    const headId = `${testId}.${book}mix.title`;
    return rows.length === 0 ? null : <div className="gx-peer-mix" key={book}><h3 className="gx-h3" id={headId}>{title}</h3><PeerTable rows={rows} testId={`${testId}.${book}mix`} caption={title} labelledBy={headId} bankNames={names} medianLabel="Median" firstColumn="Product" foldLevel={false} reserveRank /></div>;
  };
  return <>{mix("loans", "Loan mix: share of loans by product")}{mix("deposits", "Deposit mix: share of deposits by product")}</>;
}
